import { pathWithLocale } from '@/lib/i18n/locale-path'

export const paths = {
  home: '/',
  platform: '/platform',

  products: '/products',
  productsPosCustomerExperience: '/products/pos-customer-experience',
  productsCentralMenu: '/products/central-menu-management',
  productsKitchenOrchestration: '/products/kitchen-orchestration',
  productsOnlineOrderOmnichannel: '/products/online-order-omnichannel',
  productsLoyalty: '/products/loyalty',
  productsIntegrationHub: '/products/integration-hub',
  productsPromotionManagement: '/products/promotion-management',
  productsInventoryLogistic: '/products/inventory-logistic',
  productsCrmCdp: '/products/crm-cdp',
  productsReportDataWarehouse: '/products/report-data-warehouse',

  solutions: '/solutions',
  solutionsCoffeeChainQsr: '/solutions/coffee-chain-qsr',
  solutionsMultiBrand: '/solutions/multi-brand-restaurant-groups',
  solutionsFranchising: '/solutions/franchising-network',
  solutionsMultinationalFb: '/solutions/multinational-fb',
  solutionsChainReadyIndependent: '/solutions/chain-ready-independent',

  customers: '/customers',
  partners: '/partners',

  insights: '/insights',
  insightsCaseStudies: '/insights/case-studies',
  insightsWhitepapers: '/insights/whitepapers',
  insightsPerspectives: '/insights/perspectives',
  insightsEngineering: '/insights/engineering',
  insightsTechnologySolutions: '/insights/technology-solutions',

  company: '/company',
  companyCareers: '/company/careers',

  systemStatus: '/system-status',
  contact: '/contact',
  privacy: '/privacy',
  terms: '/terms',
} as const

export const buildCaseStudyHref = (locale: string, slug: string) => {
  if (/^https?:\/\//i.test(slug)) return slug
  return pathWithLocale(locale, `${paths.insightsCaseStudies}/${slug}`)
}

export const insightCategorySlugs = {
  caseStudies: 'case-studies',
  whitepapers: 'whitepapers',
  perspectives: 'perspectives',
  engineering: 'engineering',
  technologySolutions: 'technology-solutions',
} as const

export const insightCategoryPathMap: Array<{ categorySlug: string; basePath: string }> = [
  { categorySlug: insightCategorySlugs.caseStudies, basePath: paths.insightsCaseStudies },
  { categorySlug: insightCategorySlugs.whitepapers, basePath: paths.insightsWhitepapers },
  { categorySlug: insightCategorySlugs.perspectives, basePath: paths.insightsPerspectives },
  { categorySlug: insightCategorySlugs.engineering, basePath: paths.insightsEngineering },
  { categorySlug: insightCategorySlugs.technologySolutions, basePath: paths.insightsTechnologySolutions },
]

export const enterpriseNavItems = [
  { href: paths.products, labelKey: 'products' as const },
  { href: paths.solutions, labelKey: 'solutions' as const },
  { href: paths.insights, labelKey: 'insights' as const },
  { href: paths.partners, labelKey: 'partners' as const },
  { href: paths.companyCareers, labelKey: 'careers' as const },
] as const

export const sitemapPathnames = [
  '',
  paths.platform,
  paths.products,
  paths.productsPosCustomerExperience,
  paths.productsCentralMenu,
  paths.productsKitchenOrchestration,
  paths.productsOnlineOrderOmnichannel,
  paths.productsLoyalty,
  paths.productsIntegrationHub,
  paths.productsPromotionManagement,
  paths.productsCrmCdp,
  paths.productsInventoryLogistic,
  paths.productsReportDataWarehouse,
  paths.solutions,
  paths.solutionsCoffeeChainQsr,
  paths.solutionsMultiBrand,
  paths.solutionsFranchising,
  paths.solutionsMultinationalFb,
  paths.solutionsChainReadyIndependent,
  paths.customers,
  paths.partners,
  paths.insights,
  paths.insightsCaseStudies,
  paths.insightsWhitepapers,
  paths.insightsPerspectives,
  paths.insightsEngineering,
  paths.insightsTechnologySolutions,
  paths.company,
  paths.companyCareers,
  paths.systemStatus,
  paths.contact,
  paths.privacy,
  paths.terms,
] as const
